module.exports = __webpack_public_path__ + "img/logo-linkaja_qris-active.b0ec7fbb.svg";